<template>
  <div class="grid-view">
    <div class="main-content queryBalance">
      <search-item
        :key="identify"
        :ref="identify"
        :is-append-query="isAppendQuery"
        :show-more-scheme="true"
        :show-simple="showSimple"
        :expand-adv="true"
        :search-item-code="searchItemCode"
        :config-module="configModule"
        :grid-config-module="gridConfigModule"
        :auto-init="searchItemAutoInit"
        :custom-search-items="customSearchItems"
        :custom-sim-query-placeholder="simQueryPlaceholder"
        :col-settings="colSettings"
        @advSearchItemCallBack="fetchData"
        @simSearchItemCallBack="fetchDataBykeyWord"
        @advToggle="scrollCallback"
        @perConfigChange="value=>{perConfigName=value}"
        @refreshGrid="()=>{gridRefreshId+=1}"
      >
        <template slot="operations">
          <el-button no="dataExport" type="primary" @click="toDataExport()">{{ $t('CargoMsg.Cargo_DataExport') }}</el-button>
          <el-button no="sendBalance" type="primary" @click="toSendBalance()">{{ $t('AdvancePayment.SendBalance') }}</el-button>
          <el-button no="querySendBalanceState" type="primary" @click="toQuerySendBalanceState()">{{ $t('AdvancePayment.QuerySendBalanceState') }}</el-button>
          <el-button v-permission="['button_AdvancePayment_initializeBalance']" no="initializeBalance" type="primary" @click="toInitializeBalance()">{{ $t('AdvancePayment.InitializeBalance') }}</el-button>
        </template>
        <template slot="searchAreaHeader">
          <slot name="searchAreaHeader" />
        </template>
      </search-item>
      <div class="section grid-wrapper">
        <cargo-ag-grid
          ref="gridBalance"
          :export-file-name="$t('AdvancePayment.Balance')"
          :config-module="gridConfigModule"
          :per-config-name="perConfigName"
          :refresh-id="gridRefreshId"
          :grid-params.sync="gridParams"
          :grid-options="gridOptions"
          :column-defs="columnDefs"
          :row-data="rowData"
          :min-height="'350px'"
        />
      </div>
      <div id="footer-wrapper-tab-balance" class="pagination-wrapper">
        <div v-show="appendQuery" class="pagination-container">
          <el-pagination
            style="text-align: left;"
            :total="searchConditions.total"
            layout="total"
          />
        </div>
        <cargo-pagination
          v-show="!appendQuery"
          ref="paginationBalance"
          :config-module="gridConfigModule"
          :total="searchConditions.total"
          :page.sync="searchConditions.pageNum"
          :limit.sync="searchConditions.pageSize"
          @pagination="fetchDataByPage"
        />
      </div>
    </div>
    <!-- 初始化余额 -->
    <show-init-balances-dialog v-if="showInitBalancesDialog.visible" :customer-codes="showInitBalancesDialog.customerCodes" :visible.sync="showInitBalancesDialog.visible" @initCompleted="toQueryBalanceList" />
  </div>
</template>

<script>
import searchItem from '@/components/Cargo/Common/cargoCombinationSearch'
import AdvancedSearchOption from '@/class/cargo/model/parameters/AdvancedSearchOption'
import OperatorConstants from '@/class/cargo/model/parameters/OperatorConstants'
import { getGridSelected, recordSelectedStatus } from '@/utils/agGrid'
import { getLoading } from '@/utils/utilBaseElement'
import ColumnUtils from '@/utils/ColumnUtils'
import { cacheName, cache } from '@/utils/cacheManager'
import StrUtils from '@/utils/StrUtils'
import { queryBalanceList, pushCustomerInfo, queryCustomerInfo } from '@/api/clearing/advancePayment'
import lodash from 'lodash'
import { formatNumberToThousands } from '@/utils'
import { JobUtils } from '@/class/cargo/model/utils/JobUtils'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'
import showInitBalancesDialog from '@/views/cargo/v0/Clearing/components/advancePayment/showInitBalancesDialog'

export default {
  name: 'QueryBalance',
  components: { searchItem, showInitBalancesDialog },
  props: {
    isAppendQuery: { type: Boolean, default: false }, // 追加查询，默认不显示
    identify: { type: String, default: 'queryBalance' }, // ID
    configModule: { type: String, default: '5151' }, // 高级查询条件
    gridConfigModule: { type: String, default: '191401' }, // 列表设置
    showSimple: { type: Boolean, default: true },
    colSettings: { type: Object }
  },
  data() {
    return {
      loading: false,
      customSearchItems: [], // 自定义高级查询项
      searchItemAutoInit: true,
      searchItemCode: '查询预付款余额',
      simQueryPlaceholder: this.$t('AdvancePayment.QuickSearchBalance'),
      perConfigName: '',
      gridRefreshId: 0,
      gridParams: {},
      gridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true,
        context: {
          componentParent: this
        },
        defaultColDef: {
          resizable: true,
          filter: true
        },
        pagination: false,
        onRowSelected: this.onRowSelected,
        onRowClicked: this.onRowClicked,
        onRowDoubleClicked: this.onRowDoubleClicked
      },
      columnDefs: [
        {
          headerName: '', width: 55, checkboxSelection: true,
          sortable: false, suppressMenu: true, suppressSizeToFit: true, resizable: false,
          headerCheckboxSelection: true
        },
        { headerName: this.$t('AdvancePayment.CustomerName'), field: 'customerName', initialWidth: 200, minWidth: 200 },
        { headerName: this.$t('AdvancePayment.CustomerCode'), field: 'customerCode', initialWidth: 130, minWidth: 130 },
        { headerName: this.$t('AdvancePayment.SalesName'), field: 'salesName', initialWidth: 100, minWidth: 100 },
        {
          headerName: this.$t('AdvancePayment.ParentBranchName'),
          field: 'parentBranchName',
          initialWidth: 200,
          minWidth: 200
        },
        {
          headerName: this.$t('AdvancePayment.ParentBranchCode'),
          field: 'parentBranchCode',
          initialWidth: 130,
          minWidth: 130
        },
        { headerName: this.$t('AdvancePayment.BranchName'), field: 'branchName', initialWidth: 200, minWidth: 200 },
        { headerName: this.$t('AdvancePayment.BranchCode'), field: 'branchCode', initialWidth: 130, minWidth: 130 },
        {
          headerName: this.$t('AdvancePayment.Balance'), field: 'balance', initialWidth: 100, minWidth: 100,
          cellRenderer: (params) => {
            return params.data.initialized ? formatNumberToThousands(ColumnUtils.number2ColumnLabelFunc(params.value), 2) : '-'
          },
          cellStyle: { textAlign: 'right' }
        },
        {
          headerName: this.$t('AdvancePayment.DateCreated'), field: 'dateCreated', initialWidth: 120, minWidth: 120,
          cellRenderer: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('AdvancePayment.State'), field: 'state', initialWidth: 120, minWidth: 120,
          cellRenderer: (params) => {
            return ColumnUtils.AdvancePaymentStateLabelFun(params.value)
          }
        },
        {
          headerName: this.$t('AdvancePayment.SubmittingAmount'),
          field: 'submittingAmount',
          initialWidth: 120,
          minWidth: 120,
          cellRenderer: (params) => {
            return formatNumberToThousands(ColumnUtils.number2ColumnLabelFunc(params.value), 2)
          },
          cellStyle: { textAlign: 'right' }
        }
      ],
      rowData: [],
      searchConditions: {
        total: 0,
        pageNum: 1,
        pageSize: 20,
        snapshotConditions: [], // 高级查询条件
        requires: []
      },
      selectedItem: {}, // 表格选中项
      selections: [], // 已经选中列表
      shouldFixed: false,
      appendQuery: false, // 追加查询
      queryOfficeId: 0, // 记录查询时的分公司Id
      showInitBalancesDialog: {
        visible: false,
        customerCodes: []
      }
    }
  },
  async created() {
    await cache.load(cacheName.CONFIG)
    await this.initCustomSearchItems()
  },
  methods: {
    // 查询
    fetchData(conditions, simpleTriggerMode = false) {
      this.searchConditions.pageNum = 1
      const finallyConditions = []
      // 高级查询条件组装
      if (!simpleTriggerMode) {
        const advConditions = lodash.cloneDeep(conditions)
        // 获取追加查询条件
        this.appendQuery = JobUtils.appendQueryCondition(advConditions)
        //
        finallyConditions.push(...advConditions)
      } else {
        finallyConditions.push(...conditions)
      }
      // 【是否显示下级公司】，是根据【揽收机构】来的
      if (AdvancedSearchOption.hasField('showChildData', finallyConditions) && !AdvancedSearchOption.hasField('advancePayment.BRANCH_ID', finallyConditions)) {
        AdvancedSearchOption.removeOption('showChildData', finallyConditions)
      }
      console.log(finallyConditions)
      // 条件保存
      this.searchConditions.snapshotConditions = finallyConditions
      this.toQueryBalanceList()
    },
    // 快捷检索
    fetchDataBykeyWord(keyWord) {
      console.log('fetchDataBykeyWord', keyWord)
      if (!StrUtils.isEmpty(keyWord)) {
        const conditions = []
        const option = new AdvancedSearchOption(null, 'advancePayment.CUSTOMER_CODE', keyWord, OperatorConstants.OPERATOR_LIKE.code)
        conditions.push(option.formatObj2Json())
        //
        this.appendQuery = false
        this.fetchData(conditions, true)
      }
    },
    // 分页触发查询
    fetchDataByPage() {
      this.toQueryBalanceList()
    },
    toQueryBalanceList() {
      this.queryOfficeId = this.$store.getters.currentOfficeId
      const { snapshotConditions: conditions, requires: requires, pageNum, pageSize } = this.searchConditions
      const requestBody = { conditions, requires, branchId: this.$store.getters.currentOfficeId, pageNum, pageSize }
      requestBody.appendQuery = this.appendQuery
      this.loading = getLoading()
      const selectedStatus = recordSelectedStatus(this.gridOptions.api, 'uuid')
      queryBalanceList(requestBody).then(res => {
        let results = res.data.list
        // 追加查询数据去重
        if (this.appendQuery) {
          results = JobUtils.appendQueryRepeat(this.rowData, results, this.appendQuery)
        }
        this.rowData = results
        this.searchConditions.total = this.appendQuery ? results.length : Number(res.data.total)
        selectedStatus.revert()
      }).finally(() => {
        this.loading.close()
      })
    },
    async initCustomSearchItems() {
      const defaultSearchFields = []
      //

      if (defaultSearchFields.length > 0) {
        this.customSearchItems.push(...defaultSearchFields)
        this.searchItemAutoInit = true
      }
    },
    onRowSelected(event) {
      console.log('onRowSelected', event.data)
      this.selectedItem = {}
      if (event.node.selected && event.data) {
        this.selectedItem = event.data
      }
    },
    onRowClicked(event) {
      console.log('onRowClicked', event.data)
      this.selectedItem = event.data
    },
    onRowDoubleClicked(event) {
      console.log('onRowDoubleClicked', event.data)
      this.selectedItem = event.data
      this.$emit('rowDoubleClicked', this.selectedItem)
    },
    scrollCallback() {
      this.$nextTick(() => {
        const container = document.querySelector('.parent-wrapper')
        const footer = document.getElementById('footer-wrapper-tab-balance')
        const containerHeight = container.clientHeight - footer.offsetHeight
        const offset = footer.offsetTop - container.scrollTop
        if (offset > containerHeight) {
          this.shouldFixed = true
        } else {
          this.shouldFixed = false
        }
      })
    },
    // 获取勾选的项目
    getSelections() {
      return getGridSelected(this.gridOptions)
    },
    // 导出
    toDataExport() {
      this.$refs.gridBalance.handleExportSelectedToExcel(this.gridOptions)
    },
    // 发送名单
    async toSendBalance() {
      const rows = this.getSelections()
      if (rows.length === 0) {
        this.$message.warning(this.$t('common.tips.hasOneAtleast'))
        return
      }
      if (rows.length > 1) {
        this.$message.warning(this.$t('CargoMsg.Cargo_HasOneOnly'))
        return
      }
      const customerCodes = []
      for (const row of rows) {
        if (row.state === SystemConstants.ADVANCEPAYMENT_STATE_DEFAULT.code) {
          customerCodes.push(row.customerCode)
        }
      }
      //
      if (customerCodes.length === 0) {
        this.$message.warning(this.$t('AdvancePayment.NoMatchStateBySelected', [this.$store.getters.language === 'zh' ? SystemConstants.ADVANCEPAYMENT_STATE_DEFAULT.chineseName : SystemConstants.ADVANCEPAYMENT_STATE_DEFAULT.englishName]))
        return
      }
      // 提醒
      let ifContinue = false
      const messages = []
      const h = this.$createElement
      messages.push(h('p', null, this.$t('AdvancePayment.CustomerCode') + '：' + rows[0].customerCode))
      messages.push(h('p', null, this.$t('AdvancePayment.CustomerName') + '：' + rows[0].customerName))
      messages.push(h('p', null, this.$t('AdvancePayment.BranchCode') + '：' + rows[0].branchCode))
      messages.push(h('p', null, this.$t('AdvancePayment.BranchName') + '：' + rows[0].branchName))
      messages.push(h('p', { style: 'fontSize:14px;color:red;' }, this.$t('AdvancePayment.SendCustomerRemind')))
      await this.$confirm(this.$t('AdvancePayment.SendCustomerInfo'), {
        title: this.$t('AdvancePayment.SendCustomerInfo'),
        message: h('div', null, messages),
        confirmButtonText: this.$t('CargoMsg.Cargo_Send'),
        cancelButtonText: this.$t('CargoMsg.Cargo_Cancel'),
        closeOnClickModal: false,
        type: 'warning'
      }).then(() => {
        ifContinue = true
      }).catch(() => {
      })
      if (!ifContinue) return
      this.loading = getLoading()
      pushCustomerInfo(customerCodes).then(res => {
        if (res.data) {
          this.$message.warning({
            message: this.$t('SystemMaintenance.SendFailure') + '<br>' + res.data,
            dangerouslyUseHTMLString: true
          })
        } else {
          this.$message.success(this.$t('SystemMaintenance.SendSuccess'))
          // 刷新
          this.toQueryBalanceList()
        }
      }).finally(() => {
        this.loading.close()
      })
    },
    // 查询发送名单状态
    toQuerySendBalanceState() {
      const rows = this.getSelections()
      if (rows.length === 0) {
        this.$message.warning(this.$t('common.tips.hasOneAtleast'))
        return
      }
      // 调业财的查询是单条查询
      if (rows.length > 1) {
        this.$message.warning(this.$t('CargoMsg.Cargo_HasOneOnly'))
        return
      }
      const customerCodes = []
      for (const row of rows) {
        if (row.state === SystemConstants.ADVANCEPAYMENT_STATE_SENT.code || row.state === SystemConstants.ADVANCEPAYMENT_STATE_SYNCED.code) {
          customerCodes.push(row.customerCode)
        }
      }
      //
      if (customerCodes.length === 0) {
        this.$message.warning(this.$t('AdvancePayment.NoMatchStateBySelected', [this.$store.getters.language === 'zh' ? SystemConstants.ADVANCEPAYMENT_STATE_SENT.chineseName : SystemConstants.ADVANCEPAYMENT_STATE_SENT.englishName]))
        return
      }
      this.loading = getLoading()
      queryCustomerInfo(customerCodes).then(res => {
        if (res.data) {
          this.$message.warning({
            message: this.$t('SystemMaintenance.SendFailure') + '<br>' + res.data,
            dangerouslyUseHTMLString: true
          })
        } else {
          this.$message.success(this.$t('SystemMaintenance.SendSuccess'))
          // 刷新
          this.toQueryBalanceList()
        }
      }).finally(() => {
        this.loading.close()
      })
    },
    // 初始化余额
    toInitializeBalance() {
      const rows = this.getSelections()
      if (rows.length === 0) {
        this.$message.warning(this.$t('common.tips.hasOneAtleast'))
        return
      }
      // 调业财的查询是单条查询
      if (rows.length > 1) {
        this.$message.warning(this.$t('CargoMsg.Cargo_HasOneOnly'))
        return
      }
      const customerCodes = []
      for (const row of rows) {
        customerCodes.push(row.customerCode)
      }
      //
      if (customerCodes.length === 0) return
      this.showInitBalancesDialog.customerCodes = customerCodes
      this.showInitBalancesDialog.visible = true
    }

  }
}
</script>
